<template>

    <div>
        <live-header active-page-label="Top charts"></live-header>

        <div class="main-content d-flex">
            <div class="filter" :class="{active: filterActive}">
                <form class="filter-form">
                    <div class="form-group d-lg-block d-none" v-bind:class="{'disable': !user.id}">
                        <div class="custom-control custom-checkbox mb-3 pt-0">
                            <input type="checkbox" class="custom-control-input" id="favourites" name="favourites"
                                   v-model="filterFavourites" @change="loadMore()" v-bind:disabled="!user.id">
                            <label class="custom-control-label favourites" for="favourites"
                                   v-b-tooltip.html="'You must log in </br> to use this function!'"
                                   v-b-tooltip="{ trigger: 'hover', html: true, placement: 'bottomleft', customClass: 'disable-tooltip', disabled: user.id}"
                            >Favourite apps <img :src="user.id ? '/img/fill_star.svg' : '/img/disable_star.svg'"></label>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="sort">
                            <i class="sort-icon"></i>
                            <p><span class="sort-by">SORT BY:</span>
                                <span v-if="sort == 'desc'" @click="sortTop('asc')">1500–1</span>
                                <span v-if="sort == 'asc' || sort == null" @click="sortTop('desc')">1–1500</span>
                                <span v-if="sortShift == 'desc'" @click="sortTopShift('asc')" class="shift-sort">shift <i
                                    v-if="sortShift"
                                    class="arrow-down"></i></span>
                                <span v-if="sortShift == 'asc' || sortShift == null" @click="sortTopShift('desc')"
                                      class="shift-sort"> shift <i
                                    v-if="sortShift" class="arrow-up"></i></span>
                                <span v-if="sortUpdate == 'desc'" @click="sortTopUpdate('asc')"
                                      class="update-sort">update <i
                                    v-if="sortUpdate" class="arrow-down"></i></span>
                                <span v-if="sortUpdate == 'asc' || sortUpdate == null" @click="sortTopUpdate('desc')"
                                      class="update-sort">update <i v-if="sortUpdate" class="arrow-up"></i></span>
                            </p>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Screenshots</label>
                        <label class="radio-btn">On
                            <input type="radio" name="show-screen" value='on' v-model='showScreen'>
                            <span class="checkmark"></span>
                        </label>
                        <label class="radio-btn">Off
                            <input type="radio" name="show-screen" value='off' v-model='showScreen'>
                            <span class="checkmark"></span>
                        </label>
                    </div>
                    <div class="form-group">
                        <label>Store type</label>
                        <label class="radio-btn">App Store
                            <input type="radio" name="store-type" value='app_store' v-model='filterStoreType'
                                   @change="loadMore()">
                            <span class="checkmark"></span>
                        </label>
                        <label class="radio-btn">Google Play
                            <input type="radio" name="store-type" value='play_market' v-model='filterStoreType'
                                   @change="loadMore()">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                    <div class="form-group">
                        <label>Application type</label>
                        <label class="radio-btn">Free
                            <input type="radio" name="type" value='27' v-model='filterType'
                                   @change="loadMore()">
                            <span class="checkmark"></span>
                        </label>
                        <label class="radio-btn">Paid
                            <input type="radio" name="type" value='30' v-model='filterType'
                                   @change="loadMore()">
                            <span class="checkmark"></span>
                        </label>
                        <label class="radio-btn">Grossing
                            <input type="radio" name="type" value='38' v-model='filterType'
                                   @change="loadMore()">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                    <div class="form-group">
                        <label>Category</label>
                        <multiselect v-model="filterCategory" track-by="id" label="name" placeholder="Select one"
                                     :options="categoryList" :searchable="false" :allow-empty="false" :show-labels="false"
                                     @input="loadMore()">
                            <template slot="singleLabel" slot-scope="{ option }" v-if="option.parentId">
                                <span>Games ({{ option.name }})</span>
                            </template>
                            <template slot="option" slot-scope="props">
                                <span :class="props.option.parentId ? 'sub-option' : ''">{{ props.option.name }}</span>
                            </template>
                        </multiselect>
                    </div>
                    <div class="form-group">
                        <label>Country</label>
                        <multiselect v-model="filterCountry" track-by="code" label="label" placeholder="Selected countries"
                                     :options="countryList" :searchable="false" :allow-empty="false" :show-labels="false"
                                     @input="loadMore()">
                        </multiselect>
                    </div>
                    <div class="form-group mb-0">
                        <a class="bmc-button" target="_blank" href="https://www.buymeacoffee.com/storeglide"
                           style="margin-top: 10px;margin-bottom: 20px;">
                            <img src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg" alt="Buy me a coffee">
                            <span style="margin-left:5px;font-size:28px !important;">Buy me a coffee</span>
                        </a>
                    </div>
                    <div class="form-group">
                        <div class="custom-control custom-checkbox mb-3 pt-0">
                            <input type="checkbox" class="custom-control-input" id="remember" name="remember"
                                   v-model="filterRemember" @change="saveCookies()">
                            <label class="custom-control-label" for="remember">Remember my filter</label>
                        </div>
                    </div>
                    <div class="form-group d-lg-none d-block">
                        <div class="social">
                            <p class="social-description">Every day we publish video reviews on new hypercasual games.</p>
                            <div class="icons">
                                <a href="https://instagram.com/storeglide?igshid=kkso8smkzn13" target="_blank">
                                    <img src="/img/instagram.svg" class="instagram"></a>
                                <a href="https://vt.tiktok.com/yqTjdN/" target="_blank">
                                    <img src="/img/tik-tok.svg" class="tik-tok"></a>
                                <a href="https://t.me/storeglide" target="_blank">
                                    <img src="/img/telegram.svg" class="telegram"></a>
                            </div>
                        </div>
                    </div>
                </form>

            </div>
            <div class="top-application-list">
                <form class="form-inline md-form form-sm search-form" :class="{active: searchActive}">
                    <div class="sort">
                        <i class="sort-icon"></i>
                        <p><span class="sort-by">SORT BY:</span>
                            <span v-if="sort == 'desc'" @click="sortTop('asc')">1500–1</span>
                            <span v-if="sort == 'asc' || sort == null" @click="sortTop('desc')">1–1500</span>
                            <span v-if="sortShift == 'desc'" @click="sortTopShift('asc')" class="shift-sort">shift <i
                                v-if="sortShift"
                                class="arrow-down"></i></span>
                            <span v-if="sortShift == 'asc' || sortShift == null" @click="sortTopShift('desc')"
                                  class="shift-sort"> shift <i
                                v-if="sortShift" class="arrow-up"></i></span>
                            <span v-if="sortUpdate == 'desc'" @click="sortTopUpdate('asc')" class="update-sort">update <i
                                v-if="sortUpdate" class="arrow-down"></i></span>
                            <span v-if="sortUpdate == 'asc' || sortUpdate == null" @click="sortTopUpdate('desc')"
                                  class="update-sort">update <i v-if="sortUpdate" class="arrow-up"></i></span>
                        </p>
                    </div>
                    <input class="form-control form-control-sm" type="text" placeholder="Search by app or publisher"
                           aria-label="Search" v-model="q" v-bind:class="{'search-fill': q !== ''}">
                    <i class="fa fa-search" aria-hidden="true"></i>
                </form>
                <ul class="apps-list" v-if="results">
                    <li class="app" v-for="(result, idx) in results" v-bind:class="{'app-division': showScreen == 'on'}">
                        <div class="content">
                            <div class="rating-number">

                                <span>{{ result.last }}</span>
                                <span class="rating-up"
                                      v-if="result.last < result.prev">{{ result.prev - result.last }}</span>
                                <span class="rating-down"
                                      v-if="result.last > result.prev">{{ result.last - result.prev }}</span>

                            </div>
                            <div class="logo" v-if="result.application.icon">
                                <img v-lazy="result.application.icon" :alt="result.application.name"/>
                            </div>
                            <div class="description">
                                <span class="name">{{ result.application.name }}</span>
                                <a class="author" href="#">{{ result.application.publisher_name }}</a>
                                <span class="date" v-if="result.application.release_date">update: {{
                                        result.application.release_date | moment("YYYY-MM-DD")
                                    }}</span>
                            </div>
                            <div class="additional">
                                <a :href="result.application.url" class="download"
                                   v-bind:class="result.store_type == 'app_store' ? 'app-store' : 'play-market'"
                                   target="_blank"
                                   @click="sendAppEvent(result.application.app_id)"
                                   title="Go to App Store">Download</a>
                                <img
                                    :src="user.id ? result.is_favourite ? '/img/fill_star.svg':'/img/stroke_star.svg' : '/img/disable_stroke_star.svg'"
                                    v-bind:class="{'disable': !user.id}"
                                    class="favourite-icon" @click="markFavourite(idx)"
                                    :id="'tooltip-' + result.id">

                                <b-tooltip ref="tooltip" :target="'tooltip-' + result.id" placement="bottom"
                                           custom-class="disable-tooltip" :disabled="user.id != null">
                                    You must log in </br> to use this function!
                                </b-tooltip>
                            </div>
                        </div>
                        <div class="gallery-container" v-if="result.application.gallery && showScreen == 'on'">
                            <ul class="gallery">
                                <li class="item" v-for="gallery in result.application.gallery">
                                    <img v-if="filterStoreType == 'app_store'" :src="imageFormatting(gallery)" alt="#"/>
                                    <img v-if="filterStoreType == 'play_market'" :src="gallery" alt="#"/>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>

                <div class="not-found" v-if="this.filterFavourites && results.length == 0">
                    <img src="/img/not_found.svg" class="emoji">
                    <p>No added applications.</p>
                    <p>Click<img src="/img/stroke_star.svg" class="star">to track favourite apps. </p>
                </div>
                <button class="top-btn" @click="scrollToTop()" v-if="results"><img src="/img/top_btn_arrow.svg"></button>
            </div>
        </div>
    </div>


</template>

<script>

import {mapGetters} from "vuex";
import LiveHeader from './custom/LiveHeaderComponent';

export default {
    name: 'App',
    components: {
        LiveHeader
    },
    computed: mapGetters(['searchActive', 'filterActive']),
    data() {
        return {
            q: '',
            results: {},
            currentPage: 1,
            bottom: false,
            inProgress: false,
            sort: 'asc',
            sortUpdate: null,
            sortShift: null,
            filterRemember: this.$cookies.isKey("top-filter-remember") ? this.$cookies.get("top-filter-remember") : false,
            filterStoreType: this.$cookies.isKey("top-filter-store-type") ? this.$cookies.get("top-filter-store-type") : 'app_store',
            filterType: this.$cookies.isKey("top-filter-pop-id") ? this.$cookies.get("top-filter-pop-id") : 27,
            filterCategory: this.$cookies.isKey("top-filter-category") ? this.$cookies.get("top-filter-category") : {
                id: 6014,
                name: 'Games'
            },
            filterFavourites: this.$cookies.isKey("top-filter-favourites") ? this.$cookies.get("top-filter-favourites") === "true" : false,
            showScreen: this.$cookies.isKey("show-screen") ? this.$cookies.get("show-screen") : 'on',
            categoryList: [],
            filterCountry: this.$cookies.isKey("top-filter-country") ? this.$cookies.get("top-filter-country") : {
                code: 'us',
                label: 'United States'
            },
            countryList: [],
            user: {}
        };
    },

    watch: {
        q(after, before) {
            this.loadMore();
            this.loader.hide();
        },
        filterStoreType() {
            this.loadCategories();
        },
        bottom(bottom) {
            if (bottom) {
                this.loadMore(this.currentPage + 1);
            }
        },
        inProgress() {
            if (this.inProgress) {
                this.loader = this.$loading.show({loader: 'dots', backgroundColor: '#ffffff', opacity: 0});
            } else {
                this.loader.hide();
            }
        },
    },
    mounted() {

        window.addEventListener('scroll', () => {
            this.bottom = this.bottomVisible()
        });

        this.loadMore(this.currentPage);
        this.loadCountries();
        this.loadCategories();
        this.loadUser();

        $('.favourite-btn:not(.disabled)').on('click', () => {
            if ($('.favourite-btn').hasClass('is-active')) {
                this.filterFavourites = true;
            } else {
                this.filterFavourites = false;
            }
            this.loadMore(this.currentPage);
        });
    },

    methods: {
        imageFormatting(text) {
            return String(text).slice(0, -13) + '318x318bb.jpg';
        },
        loadMore: _.debounce(function (page = 1) {
            this.saveCookies();
            this.loader = this.$loading.show({loader: 'dots', backgroundColor: '#ffffff', opacity: 0});
            var params = {q: this.q, page: page};
            params['pop-id'] = this.filterType;
            params['store-type'] = this.filterStoreType;
            params['category-id'] = this.filterCategory.id;
            params['location-code'] = this.filterCountry.code;
            if (this.sort) {
                params['sort'] = this.sort;
            }
            if (this.sortUpdate) {
                params['sort-update'] = this.sortUpdate;
            }
            if (this.sortShift) {
                params['sort-shift'] = this.sortShift;
            }
            if (this.filterFavourites) {
                params['favourite'] = this.filterFavourites;
            }

            if (this.user) {
                params['user-id'] = this.user.id
            }
            axios.get("/api/top-application", {
                params: params
            }).then(response => {
                if (page === 1) {
                    this.results = response.data.data;
                } else {
                    this.results = this.results.concat(response.data.data);
                }

                $.each(this.results, function (i, item) {
                    var rating = item.rating;
                    item.last = parseInt(rating[rating.length - 1]);
                    item.prev = typeof rating[rating.length - 2] !== 'undefined' ? parseInt(rating[rating.length - 2]) : item.last;
                });

                this.currentPage = response.data.current_page;
                this.loader.hide();
            });
        }, 500),
        bottomVisible() {
            return $(window).scrollTop() + $(window).height() > $(document).height() - 300;
        },
        scrollToTop() {
            window.scrollTo(0, 0);
        },
        markFavourite(id) {

            if (!this.user.id) {
                var root = this;
                root.$refs.tooltip[id].$emit('open');
                setTimeout(function () {
                    root.$refs.tooltip[id].$emit('close');
                }, 2000);
                return;
            }

            if (!this.results[id].is_favourite) {
                axios.post("/api/favourite/create", {
                    user_id: this.user.id,
                    app_id: this.results[id].application.id,
                    type: 'top'

                }).then(response => {
                    if (response.data.status) {
                        this.results[id].is_favourite = true;
                        this.results = JSON.parse(JSON.stringify(this.results));
                    }
                });

            } else {
                axios.post("/api/favourite/delete", {
                    user_id: this.user.id,
                    app_id: this.results[id].application.id,
                    type: 'top'
                }).then(response => {
                    if (response.data.status) {
                        this.results[id].is_favourite = false;
                        this.results = JSON.parse(JSON.stringify(this.results));
                    }
                    if (this.filterFavourites) {
                        this.results.splice(id, 1);
                    }

                });

            }


        },

        loadCountries: function (page = 1) {
            var locations = [];
            axios.get("/api/countries").then(response => {
                $.each(response.data, function (i, item) {
                    if (item.is_popular) {
                        locations.push(item);
                    }
                });
                this.countryList = locations;
            });
        },
        loadUser: function () {
            axios.get("/auth/get-user").then(response => {
                this.user = response.data;
            });
        },
        loadCategories: function () {
            axios.get("/api/categories").then(response => {
                this.categoryList = response.data;
            });
        },
        sendAppEvent(id) {
            ga('send', 'event', {
                'eventAction': 'game_pressed',
                'eventValue': id
            });
        },
        sortTop(sort) {
            this.sort = sort;
            this.sortUpdate = null;
            this.sortShift = null;
            this.loadMore();
        },
        sortTopUpdate(sort) {
            this.sortUpdate = sort;
            this.sort = null;
            this.sortShift = null;
            this.loadMore();
        },
        sortTopShift(sort) {
            this.sortShift = sort;
            this.sort = null;
            this.sortUpdate = null;
            this.loadMore();
        },
        handleOpenDate() {
            $('.mx-input').css({"border-bottom-right-radius": "0", "border-bottom-left-radius": "0"});
        },
        handleCloseDate() {
            $('.mx-input').css({"border-radius": "20px"});
        },
        closeDateRage() {
            if (this.$refs.datePicker.popupVisible) {
                this.$refs.datePicker.closePopup()
            }
        },
        saveCookies() {
            if (this.filterRemember) {
                this.$cookies.set('top-filter-pop-id', this.filterType);
                this.$cookies.set('top-filter-store-type', this.filterStoreType);
                this.$cookies.set('top-filter-category', this.filterCategory);
                this.$cookies.set('top-filter-country', this.filterCountry);
                this.$cookies.set('top-filter-remember', this.filterRemember);
                this.$cookies.set('top-filter-favourites', this.filterFavourites);
                this.$cookies.set('show-screen', this.showScreen);
            } else {
                this.$cookies.remove("top-filter-pop-id");
                this.$cookies.remove("top-filter-store-type");
                this.$cookies.remove("top-filter-category");
                this.$cookies.remove("top-filter-country");
                this.$cookies.remove("top-filter-remember");
                this.$cookies.remove("top-filter-favourites");
                this.$cookies.remove('show-screen');
            }
        }
    },


}


</script>
